/**
 * The Grup Lideri badge: a lyre (frame with curled arms, yoke, base and three strings), drawn in the current colour.
 * It fills its badge: the viewBox adds the margin around the 24-unit drawing (so the browser never rounds a
 * half-pixel offset, which pushed the lyre left) and starts 0.85 down so the lyre, heavier at the bottom, looks centred.
 */
export function LyreIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="-3 -2.15 30 30"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M9 20.5C5.6 18.6 4.6 13.6 7 10.4C8.6 8.3 7.8 5.6 5.6 4.4" />
      <path d="M15 20.5C18.4 18.6 19.4 13.6 17 10.4C15.4 8.3 16.2 5.6 18.4 4.4" />
      <path d="M6.8 8.2H17.2M8 20.5H16" />
      <path d="M10 8.2V20.5M12 8.2V20.5M14 8.2V20.5" strokeWidth="1.3" />
    </svg>
  );
}
